import styled from "styled-components";

export const RowDivider = styled.section`
  height: 7px;
  border-bottom: 1px solid rgb(229, 231, 231);
  margin: 15px auto 7px auto;
`;
